export const SET_PAGE_DATA = 'SET_PAGE_DATA'
export const SET_CONSENT = 'SET_CONSENT'
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'
export const SET_ERROR = 'SET_ERROR'
export const ADD_CORNER_ELEMENT = 'ADD_CORNER_ELEMENT'
export const REMOVE_CORNER_ELEMENT = 'REMOVE_CORNER_ELEMENT'
export const SET_MODAL_OPEN = 'SET_MODAL_OPEN'
export const ADD_BODY_CLASS = 'ADD_BODY_CLASS'
export const REMOVE_BODY_CLASS = 'REMOVE_BODY_CLASS'
